import { TableItem } from 'components/atoms';
import { FooterTable } from 'components/organisms';
import { useInfiniteTable } from 'hooks/useInfiniteTable';
import { useParamId } from 'hooks/useParamId';
import i18n from 'locales/i18n';
import { useTranslation } from 'react-i18next';
import {
  useGetStatementUnrelatedRowsInfinite,
  useGetStatementUnrelatedRowsStatistics,
} from 'services/statements';
import { formatCurrency } from 'utils/global/currency.utils';

const UnrelatedRows = () => {
  const id = useParamId('statements');
  const rows = useGetStatementUnrelatedRowsInfinite(id);
  const stats = useGetStatementUnrelatedRowsStatistics(id);

  const { t } = useTranslation();

  const tableData = useInfiniteTable(rows, { selectable: false });

  return (
    <FooterTable
      id={'UnrelatedRows'}
      size='compact'
      {...tableData}
      // displayMode
      columns={[
        {
          label: t('input.label.identifier'),
          renderCell: item => (
            <TableItem>
              {!!item.ean?.length && (
                <TableItem.Text text={item.ean} isSupplementary />
              )}
              {!!item.isrc?.length && (
                <TableItem.Text text={item.isrc} isSupplementary />
              )}
              {!!item.channelId?.length && (
                <TableItem.Text text={item.channelId} isSupplementary />
              )}
              {!!item.videoId?.length && (
                <TableItem.Text text={item.videoId} isSupplementary />
              )}
              {!!item.assetId?.length && (
                <TableItem.Text text={item.assetId} isSupplementary />
              )}
            </TableItem>
          ),
          resize: true,
          footer: t('table.total'),
        },

        {
          label: t('input.label.country'),
          renderCell: item => (
            <TableItem>
              <TableItem.Text
                text={
                  i18n.language === 'en'
                    ? item.country.englishName
                    : item.country.polishName
                }
              />
              {item.countryCode && (
                <TableItem.Text text={item.countryCode} isSupplementary />
              )}
            </TableItem>
          ),
          resize: true,
        },
        {
          label: t('input.label.totalValue'),
          renderCell: item => (
            <TableItem>
              <TableItem.Text
                text={formatCurrency(item.totalValue, { fractionDigits: 4 })}
              />
              <TableItem.Text
                text={`${formatCurrency(item.unitPrice, {
                  fractionDigits: 4,
                })} x ${item.quantity}`}
                isSupplementary
              />
            </TableItem>
          ),
          footer: `${
            stats.data?.allNetAmount
              ? formatCurrency(stats.data?.allNetAmount, { fractionDigits: 4 })
              : '-'
          }`,
        },
      ]}
    />
  );
};

export default UnrelatedRows;
